<template>
    <div
        ref="dropzone"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        class="
            bg-white
            flex flex-col
            items-center
            justify-center
            mb-6
            py-4
            border-dashed border border-gray-400
        "
        style="min-height: 15rem"
    >
        <div>
            <input
                type="file"
                multiple
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute"
                ref="file"
                @change="onChange"
            />

            <div class="text-center">
                <div>You may upload more than one file at once.</div>

                <div class="inline-block">
                    <label
                        for="assetsFieldHandle"
                        class="
                            block
                            cursor-pointer
                            p-2
                            my-2
                            text-white
                        "
                        style="background-color: #1c4ed8"
                    >
                        Upload files
                    </label>
                </div>

                <div>or drag and drop files here</div>
            </div>
        </div>

        <div
            class="mt-4 px-5 w-full md:w-1/2"
            v-if="filesUploading.length"
            v-cloak
        >
            <div
                class="text-sm p-1 border border-gray-200 my-1 rounded px-2"
                v-for="file in filesUploading"
                :key="file.name"
            >
                <div>{{ file.name }}</div>

                <div
                    class="text-gray-400"
                    :class="{
                        'text-green-400': file.status === 'success',
                        'text-red-400': file.status === 'error',
                    }"
                >
                    {{ file?.message }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    emits: ["uploadComplete"],
    components: {},
    data() {
        return {
            filesUploading: [],
        };
    },
    methods: {
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!this.$refs.dropzone.classList.contains("bg-gray-200")) {
                this.$refs.dropzone.classList.remove("bg-white");
                this.$refs.dropzone.classList.add("bg-gray-200");
            }
        },
        dragleave(event) {
            this.$refs.dropzone.classList.add("bg-white");
            this.$refs.dropzone.classList.remove("bg-gray-200");
            console.log(event)
        },
        drop(event) {
            event.preventDefault();

            this.$refs.dropzone.classList.add("bg-white");
            this.$refs.dropzone.classList.remove("bg-gray-200");

            this.uploadFile(event.dataTransfer.files);
        },
        onChange() {
            this.uploadFile(this.$refs.file.files);
        },
        async uploadFile(dataFiles) {
            const beforeUnloadListener = (event) => {
                event.preventDefault();
                return (event.returnValue = "Are you sure you want to exit?");
            };

            window.addEventListener("beforeunload", beforeUnloadListener);

            for (let count = 0; count < dataFiles.length; count++) {
                let tempFile = dataFiles[count];

                let tempId = Math.random() * 10000000;

                this.filesUploading.push({
                    name: tempFile.name,
                    status: "preparing",
                    message: "Preparing...",
                    id: tempId,
                    file: tempFile,
                });
            }

            for (let count = 0; count < this.filesUploading.length; count++) {
                if (this.filesUploading[count].status === "preparing") {
                    this.filesUploading[count].status = "uploading";
                    this.filesUploading[count].message = "Uploading...";
                    let tempFile = this.filesUploading[count].file;

                    var formData = new FormData();
                    formData.append("file", tempFile);
                    formData.append("type", "brand-guideline-assets");

                    try {
                        await axios.post("/api/brand-guideline", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });

                        this.filesUploading.map((item) => {
                            if (item.id === this.filesUploading[count].id) {
                                item.status = "success";
                                item.message = "Success!";
                                return item;
                            }
                            return item;
                        });

                        this.$emit("uploadComplete");
                    } catch (error) {
                        if (error.response.status === 422) {
                            this.filesUploading.map((item) => {
                                if (item.id === this.filesUploading[count].id) {
                                    item.status = "error";
                                    item.message =
                                        error.response.data.errors.images[0];
                                    return item;
                                }
                                return item;
                            });
                        } else {
                            this.filesUploading.map((item) => {
                                if (item.id === this.filesUploading[count].id) {
                                    item.status = "error";
                                    item.message = "Something went wrong.";
                                    return item;
                                }
                                return item;
                            });
                        }
                    }
                }
            }

            window.removeEventListener("beforeunload", beforeUnloadListener);
        },
    },
};
</script>

<style scoped>
</style>
